import { About, Application, CheckSelfInfo, AASTheme, User } from '../../clients/aasServerClient.generated';
import {
    ActionTypeNames, AnonymousLoginAction,
    AuthenticationStateChangedAction, CheckLoginAction, CheckResetPasswordTokenAction, ConfirmActiveDirectoryAction,
    DialogClearAction, DialogSuccessAction,
    FetchAllDataAction, GetAboutAction, GetLoginInfoAction, GetSelfInfoAction,
    GetSessionsAction, GetThemeAction, GoToApplicationAction, GoToZendeskAction,
    InvalidTokenClearAction,
    LoginAction,
    LoginAsAction,
    LogoutAction,
    LogoutAsAction,
    ResetLoadingApplicationAction,
    ResetPasswordAction,
    SendPasswordResetAction,
    SetAboutAction,
    SetAuthReqSourceAction,
    SetInvalidTokenAction,
    SetSelfInfoAction,
    SetSessionsAction,
    SetThemeAction,
    UpdateAccountAction,
    VerifyEmailAction
} from './actions';
import { State } from './state';

export function checkLogin(): CheckLoginAction {
    return {
        type: ActionTypeNames.CheckLogin
    };
}

export function getLoginInfo(): GetLoginInfoAction {
    return {
        type: ActionTypeNames.GetLoginInfo
    };
}

export function fetchAllData(): FetchAllDataAction {
    return {
        type: ActionTypeNames.FetchAllData
    };
}

export function getTheme(): GetThemeAction {
    return {
        type: ActionTypeNames.GetTheme
    };
}

export function getAbout(): GetAboutAction {
    return {
        type: ActionTypeNames.GetAbout
    };
}

export function getSessions(): GetSessionsAction {
    return {
        type: ActionTypeNames.GetSessions
    };
}

export function getSelfInfo(): GetSelfInfoAction {
    return {
        type: ActionTypeNames.GetSelfInfo
    };
}

// tslint:disable-next-line:variable-name
export function login(email: string, password: string, remember_me: boolean,
    task: string, url: string, application: string, queryString: string): LoginAction {
    return {
        email, password, remember_me, task, url, application, queryString,
        type: ActionTypeNames.Login,
    };
}

export function logout(): LogoutAction {
    return {
        type: ActionTypeNames.Logout
    };
}

export function loginAs(id: string, refreshTable?: boolean): LoginAsAction {
    return {
        id,
        refreshTable,
        type: ActionTypeNames.LoginAs,
    };
}

export function logoutAs(checkSelf?: boolean, refreshTable?: boolean): LogoutAsAction {
    return {
        checkSelf,
        refreshTable,
        type: ActionTypeNames.LogoutAs,
    };
}

export function sendPasswordReset(email: string): SendPasswordResetAction {
    return {
        email,
        type: ActionTypeNames.SendPasswordReset
    };
}

export function resetPassword(
    id: string, token: string,
    // tslint:disable-next-line:variable-name
    new_password: string, confirm_new_password: string
): ResetPasswordAction {

    return {
        confirm_new_password, id,
        new_password, token,
        type: ActionTypeNames.ResetPassword
    };
}

export function checkResetPasswordToken(id: string, token: string): CheckResetPasswordTokenAction {
    return {
        id,
        token,
        type: ActionTypeNames.CheckResetPasswordToken
    };
}

export function confirmActiveDirectory(id: string, token: string): ConfirmActiveDirectoryAction {
    return {
        id,
        token,
        type: ActionTypeNames.ConfirmActiveDirectory
    };
}

export function verifyEmail(id: string, token: string): VerifyEmailAction {
    return {
        id,
        token,
        type: ActionTypeNames.VerifyEmail
    };
}

export function dialogSuccess(): DialogSuccessAction {
    return {
        type: ActionTypeNames.DialogSuccess
    };
}

export function dialogClear(): DialogClearAction {
    return {
        type: ActionTypeNames.DialogClear
    };
}

export function setInvalidToken(invalidToken: boolean): SetInvalidTokenAction {
    return {
        invalidToken,
        type: ActionTypeNames.SetInvalidToken
    };
}

export function invalidTokenClear(): InvalidTokenClearAction {
    return {
        type: ActionTypeNames.InvalidTokenClear
    };
}

export function authenticationStateChanged(newState: Partial<State>): AuthenticationStateChangedAction {
    return {
        newState,
        type: ActionTypeNames.AuthenticationStateChanged,
    };
}

export function setTheme(theme: AASTheme): SetThemeAction {
    return {
        theme,
        type: ActionTypeNames.SetTheme
    };
}

export function setAbout(about: About): SetAboutAction {
    return {
        about,
        type: ActionTypeNames.SetAbout
    };
}

export function setSessions(sessions: User[]): SetSessionsAction {
    return {
        sessions,
        type: ActionTypeNames.SetSessions,
    };
}

export function setSelfInfo(selfInfo: CheckSelfInfo): SetSelfInfoAction {
    return {
        selfInfo,
        type: ActionTypeNames.SetSelfInfo,
    };
}

export function goToApplication(id: string): GoToApplicationAction {
    return {
        id,
        type: ActionTypeNames.GoToApplication,
    };
}

export function resetLoadingApplication(): ResetLoadingApplicationAction {
    return {
        type: ActionTypeNames.ResetLoadingApplication,
    };
}

export function anonymousLogin(token: string): AnonymousLoginAction {
    return {
        token,
        type: ActionTypeNames.AnonymousLogin,
    };
}

export function goToZendesk(): GoToZendeskAction {
    return {
        type: ActionTypeNames.GoToZendesk,
    };
}

export function updateAccount(
    email: string, confirmEmail: string,
    firstName: string, lastName: string): UpdateAccountAction {
        return {
            confirmEmail, email, firstName, lastName,
            type: ActionTypeNames.UpdateAccount
        };
}

export function setAuthReqSource(
  task: string = '',
  url: string = '',
  application: string = '',
  queryString: string = ''
): SetAuthReqSourceAction {
  return {
    task,
    url,
    application,
    queryString,
    type: ActionTypeNames.SetAuthReqSource,
  };
}